<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/Welcome' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>工行支付列表</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 卡片 -->
    <el-card class="box-card" style="margin-top:20px">
      <!-- 搜索  新增-->
          <el-form
            size="mini"
            :inline="true"
            :model="searchForm"
            :rules="searchRules"
            ref="searchForRef"
            label-width="100px"
            autocomplete="on"
          >
            <el-form-item>
              <el-input v-model="searchForm.poxy_name" placeholder="所属代理商"  clearable type="text"></el-input>
            </el-form-item>
            <el-form-item>
              <el-input v-model="searchForm.cusid" placeholder="商户编号" clearable type="text"></el-input>
            </el-form-item>
            <el-form-item>
              <el-input v-model="searchForm.service_cusid" placeholder="服务商编号" clearable type="text"></el-input>
            </el-form-item>
            <el-form-item>
              <el-date-picker
                      v-model="searchForm.pay_time"
                      type="month"
                      placeholder="请选择支付月份">
              </el-date-picker>
            </el-form-item>
            <el-form-item>
            <el-button type="success" size="mini" @click="searchSubmit()">搜索</el-button>
            </el-form-item>
          </el-form>

      <!-- 表格 -->
      <!-- 表格 -->
      <el-table
        ref="multipleTable"
        :data="tableLoadData"
        size="mini"
        stripe
        border
      >
        <el-table-column :index="indexMethod" type="index" label="序号" width="50"></el-table-column>
        <el-table-column
                label="所属代理"
                width="180"
        >
          <template slot-scope="scope">
            <div>{{scope.row.proxy?scope.row.proxy.real_name:''}}</div>
          </template>
        </el-table-column>
        <el-table-column
          label="商户编号"
          width="180"
        >
          <template slot-scope="scope">
            <div>{{scope.row.cusid}}</div>
          </template>
        </el-table-column>
        <el-table-column
          label="服务商号"
          width="180"
          :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            <span>{{ scope.row.service_cusid }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="月份"
          width="100"
          :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            {{ scope.row.pay_time|monthFormat }}
          </template>
        </el-table-column>
        <el-table-column
          label="金额"
          width="110"
          :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            {{ scope.row.balance }}
          </template>
        </el-table-column>

        <el-table-column
          label="创建时间"
          width="160"
          :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            <span>{{ scope.row.create_time|timeFormat}}</span>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="block" style="margin-top:10px">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[10, 20, 30, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </el-card>
    <!-- 新增编辑弹框 -->
    <ePos
      :formData="formData"
      :visible="visible"
      :title="title"
      :closeForm="closeForm"
    />
    <ePosMember
      :formData="formData"
      :visible="visible1"
      :title="title1"
      :closeForm="closeForm1"
    />

  </div>
</template>

<script>
  import ePos from "../common/ePOS.vue";
  import ePosMember from "../common/ePosMember.vue";
  import moment from 'moment'     //日期时间转换

  export default {
    name: "orderIcbcList",
    components: {
      ePos,ePosMember
    },
    props: {},
    data() {
      return {
        formData: {},
        title: "",
        visible: false,

        title1: "",
        visible1: false,

        gradeList:[],
        // 搜索
        searchForm: {
          prox_name: "",
          cusid: "",
          service_cusid: "",
          pay_time: "",
        },
        searchRules: {
          name: [
            { required: true, message: "请输入文章标题", trigger: "blur" }
          ],
        },
        // 数据
        tableLoadData: [],
        pageNum:1,// 当前页码
        pageSize:10,// 每页大小
        total:0,//总条目数

        showType: '',

        roleList: [],

        rules: {
          name: [
            { required: true, message: '请输入名称', trigger: 'blur' },
            {
              min: 3,
              max: 15,
              message: "长度在 3 到 15 个字符",
              trigger: "blur",
            }
          ],

        },

        dialogFormVisible: false,
        form: {
          name: '',
        },

      };
    },
    created() {
      this.showType = this.$route.query.showType;
      console.log(this.showType,888);
      this.DataList()
      this.departData()
    },
    mounted() {
    },
    filters: {
      //时间格式化
      timeFormat(add_time) {
        if (add_time == undefined) {
          return "";
        }
        return moment(add_time*1000).format("YYYY-MM-DD HH:mm:ss");
      },
      dateFormat(add_time) {
        if (add_time == undefined) {
          return "";
        }
        return moment(add_time*1000).format("YYYY-MM-DD");
      },
      monthFormat(add_time) {
        if (add_time == undefined) {
          return "";
        }
        return moment(add_time*1000).format("YYYY-MM");
      },
      statusFilter(status) {
        if (status == 0) {
          return "待审核";
        } else if (status == 1) {
          return "已审核";
        } else if (status == 2) {
          return "已出单";
        } else if (status == 3) {
          return "已完成";
        } else if (status == 4) {
          return "取保";
        } else if (status == 5) {
          return "退单";
        }
      },

    },
    methods: {

      goZcPay(row){
        this.title="支付参数";
        this.visible=true;
        this.formData=row;
        console.log('pay-----',row)
      },
      goPay(row){
        this.$router.push({
          path:'/merchantPayList',
          query:{
            id:row.id
          }
        })
      },
      goMorePay(row){
        this.$router.push({
          path:'/merchantPayMoreList',
          query:{
            id:row.id
          }
        })
      },

      goInfo(row){
        this.$router.push({
          path:'/proxyInfo',
          query:{
            id:row.id
          }
        })
      },
      goEdit(row){
        this.$router.push({
          path:'/posForm',
          query:{
            id:row.id
          }
        })
      },

      goCategory(){
        this.$router.push('/newsCategory')
      },
      indexMethod(index) {
        return (this.pageNum - 1) * this.pageSize + index + 1
      },
      DataList(){
        let _this=this;
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
          proxy_id:sessionStorage.getItem('proxy_id'),
          pageNum:_this.pageNum,
          pageSize:_this.pageSize,
        }
        this.$axios.findPayIcbcListP(param).then(res=>{
          if(res.code == 200){
            this.tableLoadData = res.data.data;
            this.total=res.data.total;
          }
        }).catch(error=>{
          console.log(error);
        })
      },
      // 设置每页条数
      handleSizeChange(newSize) {
        this.pageSize = newSize
        this.DataList()
      },
      // 分页跳转
      handleCurrentChange(newPage) {
        this.pageNum = newPage
        this.DataList()
      },
      departData(){
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
        }
        this.$axios.findTree(param).then(res=>{
          if(res.code == 200){
            this.rightslist = res.data.data
          }
        }).catch(error=>{
          console.log(error);
        })
      },

      // 新增
      addData() {
        this.$router.push('/proxyForm')
      },
      handelEdit(index) {
        this.id = index.data.row.id
        this.title = '编辑'
        this.form = {
          name: this.name,
        }
        this.dialogFormVisible = true
        // this.form = {...row};
        // 或者
        this.form = JSON.parse(JSON.stringify(index.data.row))
      },

      reset_dialogForm(formName) {
        this.dialogFormVisible = false
        this.$nextTick(() => {
          this.$refs[formName].resetFields()
        })
      },
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if(!this.id){
              const param = {
                name: this.form.name,
                operator_id: sessionStorage.getItem('user_id'),
                company_id: sessionStorage.getItem('company_id'),
                access_token: sessionStorage.getItem('token'),
              }
              this.$axios.insuranceCorpSave(param).then(res =>{
                console.log(res,7777);
                if(res.code == 200){
                  this.DataList()
                  this.$message.success(res.msg)
                  this.dialogFormVisible = false
                }else{
                  this.$message.error(res.msg);
                }
              })
            }else{
              const param = {
                id: this.form.id,
                name: this.form.name,
                operator_id: sessionStorage.getItem('user_id'),
                company_id:sessionStorage.getItem('company_id'),
                access_token:sessionStorage.getItem('token'),
              }
              this.$axios.insuranceCorpSave(param).then(res =>{
                if(res.code == 200){
                  this.$message.success(res.msg)
                  this.DataList()
                  this.dialogFormVisible = false
                }else{
                  this.$message.error(res.msg);
                }
              })
            }

          }
        })
      },
      searchSubmit() {
         this.pageNum=1;
         this.DataList();
      },

      handelDel(e) {
        console.log(e);
        this.$confirm('此操作将删除该分类, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const param = {
            operator_id: sessionStorage.getItem('user_id'),
            company_id:sessionStorage.getItem('company_id'),
            access_token:sessionStorage.getItem('token'),
            id: e.data.row.id,
          }
          this.$axios.insuranceCorpDel(param).then(res=>{
            if(res.code == 200){
              this.$message.success(res.msg);
              this.DataList()
            }else{
              this.$message.error(res.msg);
            }
          }).catch(error=>{
            console.log(error);
          })
        }).catch(() => {
          // 点击取消:不删除了
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
          this.DataList()
        });
        this.teamDialog = false
      },


    },
  };
</script>
<style>

</style>
